/* list.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./list.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { useIsMacro } from '../../utils/useIsMacro';
var defaultMarginStyle = null;
var styles = {
  macroMargin: "_18u01b66 _19pku2gc"
};
var defaultStyle = null;

// bullet style ordering
var UNORDERED_LIST_STYLES = ['disc', 'circle', 'square'];
var ORDERED_LIST_STYLES = ['decimal', 'lower-alpha', 'lower-roman'];

// create a type ForgeDocWihData that includes an indentLevel object, to avoid exposing indentLevel prop in ListProps

/**
 * An unordered (bulleted) or ordered (numbered) list.
 */
export var List = function List(props) {
  var forgeDoc = props.forgeDoc,
    render = props.render;
  var _ref = props.forgeDoc.props,
    type = _ref.type;
  var forgeDocWithData = forgeDoc;
  // initialise indentLevel to 0 and add to forgeDocWithData
  if (forgeDocWithData.data === undefined) {
    forgeDocWithData.data = {
      indentLevel: 0
    };
  }

  // the indentLevel is used to determine the list item style that should be rendered for that level
  var indentLevel = forgeDocWithData.data.indentLevel;
  var isMacro = useIsMacro();

  // set the list style according to the list type
  var listType = type === 'ordered' ? ORDERED_LIST_STYLES : UNORDERED_LIST_STYLES;

  // pass iterated indentLevel to child
  forgeDocWithData.children.forEach(function (child) {
    // This `if` block needs to be deprecated. `List` children should always be `ListItem`s, not another `List`
    // Using `List` as a child of `List` fails accessibility tests
    if (child.type === 'List') {
      child.data = _objectSpread(_objectSpread({}, child.data), {}, {
        indentLevel: indentLevel + 1
      });
    }
    if (child.type === 'ListItem') {
      // Iterate through children of `ListItem` to find any `List` children to pass indentLevel
      // This is to render the correct list style
      child.children.forEach(function (grandChild) {
        if (grandChild.type === 'List') {
          grandChild.data = _objectSpread(_objectSpread({}, child.data), {}, {
            indentLevel: indentLevel + 1
          });
        }
      });
    }
  });
  var listChildren = forgeDocWithData.children.map(function (child) {
    return render(child);
  });

  // We have to use "style" here since the value for the "list-style-type" property is dynamic (based on the indentation level).
  // Compiled does not support dynamic values and @compiled/babel-plugin would not be able to transform this code.
  // See https://atlassian.design/components/eslint-plugin-ui-styling-standard/migration-guide#dynamic-styles
  var listComponent = type === 'ordered' ? /*#__PURE__*/React.createElement("ol", {
    key: forgeDocWithData.key,
    style: {
      listStyleType: listType[indentLevel % listType.length]
    },
    className: ax(["_vwz41ejb _xhc01b66", "_18u0mgjw"])
  }, listChildren) : /*#__PURE__*/React.createElement("ul", {
    key: forgeDocWithData.key,
    style: {
      listStyleType: listType[indentLevel % listType.length]
    },
    className: ax(["_vwz41ejb _xhc01b66", "_18u0mgjw"])
  }, listChildren);
  if (isMacro && indentLevel === 0) {
    // Applying an additional margin when used in a macro extension point as the editor contains styling that causes decimal bullets to overflow and be cut off. The additional margin shifts the List component to prevent the cut off.
    return /*#__PURE__*/React.createElement(Box, {
      xcss: styles.macroMargin
    }, listComponent);
  }
  return listComponent;
};